/**
 * Handle decimal point values based on the currency object
 * Truncates to the nearest decimal place provided using JS toFixed() method
 * formatCurrencyWithDecimal(1245.8788,2) => 1245.89
 * formatCurrencyWithDecimal(1245.8788,3) => 1245.879
 * formatAsCurrencyWithDecimal(400,0) => 400
 * decimal value => add that or truncate to the decimal value provided
 * *
*/

import Decimal from 'decimal.js';

const truncateDecimals = (number: number, digits: number): number => {
    if (!digits) return number;

    const decimal = new Decimal(number);
    const multiplier = Decimal.pow(10, digits);
    const adjustedNum = decimal.mul(multiplier);
    const truncatedNum = adjustedNum.lt(0) ? adjustedNum.ceil() : adjustedNum.floor();

    return truncatedNum.div(multiplier)
        .toNumber();
};

export const formatCurrencyWithDecimal = (amount, decimalPoint: number, truncateZeros: boolean = false) => {
    const truncated = truncateDecimals(parseFloat(amount), decimalPoint);

    return truncated
        .toLocaleString('en-US', {
            ... !truncateZeros && { minimumFractionDigits: decimalPoint },
            maximumFractionDigits: decimalPoint
        });
};